<div class="transport-registration-further-info">
  <sc-padding>
    <sc-flex [fitHeight]="true" [centered]="true">
      <div class="content">
        <sc-flex [vertical]="true" [stretchContent]="true">
          <div *ngIf="useGlobalConnect">
            <div>
              {{
                "Warten Sie auf weitere Anweisungen in GlobalConnect für...." | translate: [
                        "tmc-yard.widgets.registration-terminal.transport-registration-further-info.useGlobalConnect",
                        translationService.language]
              }}
            </div>
            <div class="imageContainer">
              <img class="image" src="assets/customer/hochwald/global-connect_grafik-handy.webp"
              />
            </div>
          </div>

          <div *ngIf="usePhoneCall">
            <div>
              {{
                "Warten Sie bis wir sie Anrufen und Ihnen weitere Anweisungen geben" | translate: [
                        "tmc-yard.widgets.registration-terminal.transport-registration-further-info.usePhoneCall",
                        translationService.language]
              }}
            </div>
          </div>

          <div *ngIf="useSms">
            <div>
              {{
                "Warten Sie auf weitere Anweisungen per SMS" | translate: [
                        "tmc-yard.widgets.registration-terminal.transport-registration-further-info.useSms",
                        translationService.language]
              }}
            </div>
          </div>
          
          <sc-content-spacer [vertical]="true"></sc-content-spacer>
          <div class="important">
            {{
              "Achtung!!! Erst nach Abruf können Sie mit dem erhaltenen Anmelde-QRCode die Schranke öffnen. Vorher ist keine Einfahrt möglich!" | translate: [
                      "tmc-yard.widgets.registration-terminal.transport-registration-further-info.hint",
                      translationService.language]
            }}
          </div>
        </sc-flex>
      </div>
    </sc-flex>
  </sc-padding>
</div>
